const wowApp = require('angular').module('wowApp.digitalpay');

const { digitalPayAccountComponentDefinition } = require('./digital-pay-account.component');

wowApp.component('wowDigitalPayAccount', digitalPayAccountComponentDefinition);



// WEBPACK FOOTER //
// ./src/digitalpay/account/index.js